// extracted by mini-css-extract-plugin
export default {"block":"YlEaIG0m2KCRJIscUYpg","scroll":"cs2ovXPFZTc1Sb6FO316","btn":"_84Q2KmffEGX1FqUMdii"};